<template>
  <div>
    <!--Page Header-->
    <div class="row no-gutters mb-3">
      <div class="col-md-6 display-1 my-auto">{{ userTitleText }}</div>
      <div class="col-md-6 text-right" v-if="checkPermission('CreateUser')">
        <button type="button" class="btn btn-outline-success" id="add-user">+Add User</button>
      </div>
    </div>
    <!--Table Head-->
    <div class="table-head rounded-top py-2 px-0 no-gutters">
      <b-container fluid>
      <b-row class="no-gutters">
        <b-col cols="12" md="4" class="my-auto text-left">Agency Users</b-col>
        <b-col cols="12" md="8">
        <b-form-group class="search-box-admin mb-0 mt-sm-2 mt-md-0 float-md-right">
          <b-input-group>
            <b-input-group-text slot="prepend"><i class="fas fa-search"></i></b-input-group-text>
            <b-form-input v-model="filter" placeholder="Search Table" class="search-text-box-admin"></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
       </b-row>
      </b-container>
    </div>
    <b-table hover id="manage-table" class="smaller-font-content"
      :items="formartedItems"
      :fields="fields"
      :responsive="true"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-direction="sortDirection"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-compare="dateSortCompare"
      primary-key="UserId"
      @filtered="onFiltered"
    >
      <b-form-checkbox slot="status" slot-scope="data" v-model="data.value" name="check-button" :id="'user-'+data.item.UserId"  @change="toggleAll(data)" switch>
      </b-form-checkbox>
      <span slot="editUser" slot-scope="data" v-html="data.value"></span>
      <span slot="userEmail" slot-scope="data" v-html="data.value"></span>
      <span slot="products" slot-scope="data" v-html="data.value"></span>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
      <b-col md="6" class="my-1 pagination-col">
        <input-radioalt :fieldData="userStatusToggle" class="float-right"></input-radioalt>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable */
import moment from 'moment';
import fetchData from '../../../services/fetchData';
import postData from '../../../services/postData';
import common from '../../../services/common';
import InputRadioalt from '../interactive/InputRadioSwitchFilter';

export default {
  data() {
    return {
      userStatusToggle: {
        field_name: "UserStatusToggle",
        field_type: "radio",
        field_value: true,
        group_id: 1,
        index: null,
        sub_index: null,
        display_order: 3,
        section_display_order: 0,
        help_text: "",
        sub_text: "",
        placeholder: "",
        visible: true,
        is_quote_summary_field: false,
        is_enabled: true,
        is_required: true,
        script: "",
        max_length: 100,
        sub_section: "",
        sub_section_type: "",
        sub_index_section: "",
        sub_index_section_type: "",
        rules: [],
        values: [{
            display_value: "Active Users",
            internal_value: true,
            visible: true,
            display_order: 1
        }, {
            display_value: "Inactive Users",
            internal_value: false,
            visible: true,
            display_order: 2
        }],
        has_error: false,
        error: null
    },
      userMsgStatus: false,
      userName: '',
      userApiEndPoint: '',
      userTitleText: '',
      showAgencyColumn: '',
      items: [],
      originalItems:[],
      fields: [
          { key: 'name', sortable: true, sortDirection: 'desc' },
          { key: 'userRole', sortable: true, sortDirection: 'desc' },
          { key: 'userEmail', sortable: true, sortDirection: 'desc' },
          { key: 'products', sortable: true, sortDirection: 'desc' },
          { key: 'dateAdded', sortable: true, sortDirection: 'desc' },
          { key: 'status', sortable: true, sortDirection: 'desc' },
          { key: 'editUser', sortable: false },
        ],
        totalRows: 1,
        currentPage: 1,
        perPage: 20,
        pageOptions: [5, 10, 15],
        sortBy: 'name',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
    };
  },
  components: {
    InputRadioalt,
  },
  methods: {
    /**
     * custom sort logic to sort records by date
     */
    dateSortCompare(valOne, valTwo, key) {
      if(key !== 'dateAdded') {
        return null;
      }
      const a = new Date(valOne.dateAdded);
      const b = new Date(valTwo.dateAdded);
      return a>b ? -1 : a<b ? 1 : 0;
    },
    onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
      toggleAll(data) {
        if(data.value == true)
        {
          
          this.items.map((item, itemIndex) => {
            if(item.UserId === data.item.UserId)
            {
              this.items[itemIndex]._rowVariant = 'row-disable';
              this.items[itemIndex].status =  !data.value;
            }
          });
        }
        else
        {
          this.items.map((item, itemIndex) => {
            if(item.UserId === data.item.UserId)
            {
              this.items[itemIndex]._rowVariant = '';
              this.items[itemIndex].status =  !data.value;
            }
          });
        }
        const dataStatus = {
          status: !data.value
        };
        const requestParams = {
        url: '/users/'+data.item.UserId+'?status='+!data.value,
        data: '',
      };
      postData.postRuleDashboard(requestParams).then((response) => {
        this.$forceUpdate();
      }).catch((error) => {
        alert('400 client error');
      });
    },
    checkPermission(permissionName) {
      return common.checkPermission(permissionName);
    },
    getAgencyID() {
      return sessionStorage.getItem('agencyId');
    },
  },
  created() {
  },
  computed: {
  formartedItems () {
    if (!this.items) return []
    return this.items.map(item => {
      if(item.status == false)
          item._rowVariant  = 'row-disable';
      else
          item._rowVariant  = '';
      return item;
    })
  }
},
  mounted() {
    /**
     * check if incoming url has any message to display on top
     */
    if (this.$route.query.msg && this.$route.query.msg === 'UserCreated') {
      this.userMsgStatus = true;
      this.userName = (this.$route.query.carrier) ? this.$route.query.carrier : '';
    }

    // Check if user is QRP admin by checking GetAllUsers permission.
    if(this.checkPermission('GetAllUsers')) {
       this.userApiEndPoint = 'users';
       this.userTitleText = 'QuinStreet Rating Platform - Manage Users';
       this.showAgencyColumn = true;
       this.fields.splice(1, 0, { key: 'agency', sortable: true, sortDirection: 'desc' })
    }
    else {
       this.userApiEndPoint = 'agencies/'+this.getAgencyID()+'/users';
       this.userTitleText = sessionStorage.getItem('userAgency') + " - Manage Users";
       this.showAgencyColumn = false;
    }
    fetchData.getDashboard(this.userApiEndPoint).then((response) => {
      this.items = response.data.map(el => {
      let UserName;
      if(el.User.MiddleInitial !== null) {
          UserName = el.User.FirstName +" "+ el.User.MiddleInitial +" "+ el.User.LastName;
      }
      else
      {
          UserName = el.User.FirstName +" "+ el.User.LastName;
      }
      const UserAgency = el.User.AgencyName;
      const UserEmail = el.User.Email;
      const arrUserRole = [];
      el.Roles.map(function(role){
           arrUserRole.push(role.Description);
      })
      const strRoleName = arrUserRole.join(',');

      // Extracts available products
      const agencyProducts = el.Products.map((prod) => {
        if (prod.ProductId === 1) {
          return 'Auto';
        }
        if (prod.ProductId === 21) {
          return 'Home';
        }
        if (prod.ProductId === 18) {
          return 'Condo';
        }
        if (prod.ProductId === 12) {
          return 'Renters';
        }
      });

      // Reference array for ordering products
      const productsInOrder = ['Auto', 'Home', 'Condo', 'Renters'];
      const sortedProducts = [];

      productsInOrder.forEach((prod) => {
        if (agencyProducts.includes(prod)) {
          sortedProducts.push(prod);
        };
      });

      const iconDictionary = {
        auto: 'car',
        home: 'home',
        condo: 'hotel',
        renters: 'building',
      };

      const userProductIconHtml = sortedProducts.map(el => {
        let productName = el.toLowerCase();
        return `<span class="product-icon-${productName} d-inline-flex justify-content-center">${el}</span>`;
      });

      const strUserProductIcons = userProductIconHtml.join('');

      const UserStatus = el.User.IsActive;
      const DateAdded = moment(el.User.DateAdded, 'YYYY-MM-DD[T]HH:mm:ss.SSS').format('MM/DD/YYYY');
      const editUser = `<a href="javascript:void(0)" class="edit-user" data-carrier="${el.User.LoginId}"><i class="fas fa-edit" title="Edit User"></i> Edit Details</a>`;
      const UserId = el.User.LoginId;

      return {
          name: UserName,
          agency: UserAgency,
          userRole: strRoleName,
          userEmail: UserEmail,
          products: strUserProductIcons,
          dateAdded: DateAdded,
          status: UserStatus,
          editUser: editUser,
          UserId
        }
      });

      this.originalItems = this.items; // Store total received items to be used when filtering active vs inactive users
      this.items = this.originalItems.filter(item => item.status === this.userStatusToggle.field_value);

      this.totalRows = this.items.length;

      document.getElementById('manage-table').addEventListener('click', e => {
        if (e.target.classList.contains('edit-user')) {
           e.preventDefault();
          this.$router.push({ path: '/dashboard/users/manage-users/edit-user', query: { userID:  e.target.dataset.carrier } });
        }
      });
      document.getElementById('add-user').addEventListener('click', e => {
        this.$router.push({ path: '/dashboard/users/adduser'});
      });


    }).catch((error) => {
    });
  },
  watch: {
    // Updates rows to display either active OR inactive users
    'userStatusToggle.field_value': function userStatusToggle(newValue, oldValue) {
      this.items = this.originalItems.filter(item => item.status === newValue);
      this.totalRows = this.items.length;
      this.currentPage = 1;
    },
  },
};
</script>

<style scoped>
</style>

<style lang="scss">
.pagination-col .btn-group.btn-group-toggle label.btn {
  margin-top: 0 !important; // Remove to match pagination style
  margin-bottom: 0 !important; // Remove to match pagination style

  span {
    line-height: 2.5; // 2x Bootstrap's `.page-link` to match pagination style
  }
}

/**DATA TABLE STYLING**/
.table-head{
  display: block;
  color: #FFFFFF;
  background: #00162B;
}
  #manage-table thead th{
    max-width: 300px;
    min-width: 100px;
    padding: 0.375rem 0.75rem;
  }
    #manage-table tbody td{
      position: relative;
      max-width: 300px;
      min-width: 100px;
    }
      #manage-table tbody td a.edit-user{
        color: #036;
        fill: currentColor;
      }
       #manage-table tbody td a.edit-user:focus {
        box-shadow: 0 0 1px 3px #aeaeae;
        -webkit-box-shadow: 0 0 1px 3px #aeaeae;
      }
      #manage-table tbody td img{
        width: inherit !important;
        max-height: 60px !important;
      }
      #manage-table tbody td img.edit-user:after{
        content: "\f1c5" " " attr(alt);
        font-size: 16px;
        font-family: "Font Awesome 5 Pro", "Font Awesome 5 Free";
        color: #666666;
        display: block;
        position: absolute;
        top: 0.75rem;
        left: 0.75rem;
        z-index: 2;
        background-color: #fff;
      }

.edit-user {
  cursor: pointer;
}

.table-row-disable {
  background-color: #eeeeee !important;
}
span[class^='product-icon'] {
  display: inline-flex;
  color: #fff;
  border-radius: 25px;
  padding: 0.3rem;
  align-items: center;
  justify-content: space-evenly;
  margin: 0.3rem;
  width: 4.5rem;
}
span.product-icon-auto {
  background-color: #DCDFE7;
  color: #2D374C;
}
span.product-icon-home {
  background-color: #DBE5E5;
  color: #314D4D;
}
span.product-icon-condo {
  background-color: #E6E0E7;
  color: #423545;
}
span.product-icon-renters {
  background-color: #ECE1CF;
  color: #603F0B;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/user/UserManager.vue?47346f1c